module.exports = __webpack_public_path__ + "staticcomp/img/content_4.cc2568d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/7/content_4.png
// module id = vvHI
// module chunks = 39